import React, { Component } from "react";
import "./Menu.css";
import { connect } from "react-redux";
import classNames from "classnames";
import { routeCodes } from "../../config/routes";
import { NavLink, withRouter } from "react-router-dom";
import { setLanguage } from "../../actions/actions";

const designer = {
  Srpski: "DIZAJNER",
  English: "DESIGNER",
  Italian: "DESIGNER"
};

const atelier = {
  Srpski: "ATELJE",
  English: "ATELIER",
  Italian: "ATELIER"
};

const collections = {
  Srpski: "KOLEKCIJE",
  English: "COLLECTIONS",
  Italian: "COLLECTIONS"
};

const news = {
  Srpski: "VESTI",
  English: "NEWS",
  Italian: "NEWS"
};

const contact = {
  Srpski: "KONTAKT",
  English: "CONTACT",
  Italian: "CONTACT"
};

const deconstructed = {
  Srpski: "DECONSTRUCTED",
  English: "DECONSTRUCTED",
  Italian: "DECONSTRUCTED"
};

class Menu extends Component {
  render() {
    const { language, activeMenu, dispatch, closeMenu } = this.props;
    const langClasses = classNames(
      "ButtonLang",
      language === "English" && "ButtonLang--active"
    );
    const srbLangClasses = classNames(
      "ButtonLang",
      language === "Srpski" && "ButtonLang--active"
    );
    const itLangClasses = classNames(
      "ButtonLang",
      language === "Italian" && "ButtonLang--active"
    );
    const menuClasses = classNames(
      "SlidingMenu",
      activeMenu && "SlidingMenu--Active"
    );

    return (
      <div className={menuClasses}>
        <div className="MobLang">
          <button
            className={langClasses}
            onClick={() => dispatch(setLanguage("English"))}
          >
            en
          </button>
          <p className="Lang">/</p>
          <button
            className={itLangClasses}
            onClick={() => dispatch(setLanguage("Italian"))}
          >
            it
          </button>
          <p className="Lang">/</p>
          <button
            className={srbLangClasses}
            onClick={() => dispatch(setLanguage("Srpski"))}
          >
            sr
          </button>
        </div>
        <div onClick={closeMenu}>
          <NavLink className="Link" to={routeCodes.DESIGNER}>
            {designer[language]}
          </NavLink>
        </div>
        <div onClick={closeMenu}>
          <NavLink className="Link" to={routeCodes.ATELIER}>
            {atelier[language]}
          </NavLink>
        </div>
        <div onClick={closeMenu}>
          <NavLink className="Link" to={routeCodes.COLLECTIONS}>
            {collections[language]}
          </NavLink>
        </div>
        <div onClick={closeMenu}>
          <NavLink className="Link" to={routeCodes.NEWS}>
            {news[language]}
          </NavLink>
        </div>
        <div onClick={closeMenu}>
          <NavLink className="Link" to={routeCodes.CONTACT}>
            {contact[language]}
          </NavLink>
        </div>
        <div onClick={closeMenu}>
          <NavLink className="Link" to={routeCodes.DECONSTRUCTED}>
            {deconstructed[language]}
          </NavLink>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu/index.js